// extracted by mini-css-extract-plugin
export var avatar = "_q5-3";
export var avatarContainer = "_q5-2";
export var avatarSpacer = "_q5-5";
export var avatarSpacerContainer = "_q5-4";
export var avatarStackContainer = "_q5-1";
export var bubble = "_q5-0";
export var remainderBubble = "_q5-6";